import PropTypes from 'prop-types'
import React, { useState } from 'react'
import Modal from "../common/Modal/Modal";
import "./SensorDetail.scss";
import SensorFooter from "../SensorFooter/SensorFooter";
import { InteractiveItem } from '../InteractiveItem/InteractiveItem';
import Decision from "../Decision/Decision";
import Scroll from "../../../partials/Scroll/Scroll";

function SensorDetail({
    show = false,
    sensor,
    onClose,
    missionRequirements,
    missionRequirementsText,
    closeButtonText
}) {

    const [makeDecisionDialogShow, setMakeDecisionDialogShow] = useState(false)
    const [interactiveDialogShow, setInteractiveDialogShow] = useState(false)
    const [currentTabIndex, setCurrentTabIndex] = React.useState(-1)
    const [currentSection, setCurrentSection] = React.useState()
    const [containerWidth, setContainerWidth] = useState();

    React.useEffect(() => {
        if (sensor && sensor.info.length > 0) setCurrentTabIndex(0)
    }, [sensor])

    React.useEffect(() => {
        return () => setCurrentTabIndex(0)
    }, [])

    React.useEffect(() => {
        if (sensor && currentTabIndex > -1) setCurrentSection(sensor.info[currentTabIndex])
    }, [sensor, currentTabIndex])

    if (!sensor || currentTabIndex < 0) {
        return null;
    }

    return <Modal
        show={show}
        showContinue={true}
        size={'large'}
        continueCaption={sensor.nextButton}
        leftActionButtonCaption={sensor.simulationButton}
        onLeftActionButtonClick={() => { setInteractiveDialogShow(true) }}
        onContinueClick={() => { setMakeDecisionDialogShow(true) }}
    >
        <div className={"sensordetail-container"}>

            <InteractiveItem
                show={interactiveDialogShow}
                sensor={sensor}
                onComplete={() => { setInteractiveDialogShow(false) }}
            />

            <Decision
                show={makeDecisionDialogShow}
                onCancel={() => {
                    setMakeDecisionDialogShow(false)
                    if (onClose) {
                        setCurrentTabIndex(0)
                        onClose('rejected', sensor);
                    }
                }}
                sensor={sensor}
                onSelect={() => {
                    if (onClose) onClose('accepted', sensor)
                }}
                missionRequirements={missionRequirements}
                missionRequirementsText={missionRequirementsText}
                closeButtonText={closeButtonText}
            />

            <div style={{ marginBottom: ".1rem", display: "flex", gap:"1rem" }}>
                <img src={sensor.img} style={{ width: "5rem" }} />
                <h1 style={{ marginTop: "auto", marginBottom: "auto", color: "white" }}>{sensor.type}</h1>
            </div>

            <div className={"sensordetail-tabsheader"} >
                {
                    sensor.info && sensor.info.map((s, i) => {
                        return (
                            <div key={s.title} className={`sensordetail-tabcontainer `} >
                                <div
                                    className={`sensordetail-tabtitle ${i === currentTabIndex ? 'selected' : ''} `}
                                    onClick={() => { setCurrentTabIndex(i) }}
                                >{s.title}</div>
                            </div>
                        )
                    })
                }
            </div>

            <div className={'sensordetail-content-container'} >

                {
                    currentSection && currentSection.Img !== undefined
                        ? containerWidth !== "50%" && setContainerWidth("50%")
                        : containerWidth !== "100%" && setContainerWidth("100%")
                }

                {console.log(containerWidth, " containerWidth")}

                <div style={{ display: "flex", maxHeight: "275px" }}>
                    <div className={`sensordetail-content item `} style={{ width: containerWidth }}>
                        <Scroll>
                            <div
                                className={`${!currentSection ? 'hidden' : ''}`}
                                style={{ maxHeight: "260px" }}
                                dangerouslySetInnerHTML={{
                                    __html: currentSection && currentSection.content,
                                }} />
                        </Scroll>
                    </div>

                    {
                        currentSection && currentSection.Img !== undefined
                            ? (
                                <div style={{ width: "50%" }}>
                                    <img src={currentSection.Img} style={{ maxWidth: "100%", maxHeight: "90%" }} />
                                </div>
                            )
                            : ""
                    }
                </div>

                <div className={'sensordetail-kpi-container item'} >
                    {sensor && <SensorFooter sensor={sensor} />}
                </div>
            </div>

        </div>
    </Modal>
}

export default SensorDetail;

SensorDetail.propTypes = {
    show: PropTypes.bool.isRequired
}

SensorDetail.defaultProps = {
    show: false
}
